<dx-select-box #selectBox
    [dataSource]="platforms"
    [value]="selectedItem"
    displayExpr="name"
    valueExpr="id"
    [disabled]="loading"
    [readOnly]="readonly"
    (selectedItemChange)="onSelectedItemChange($event)">
</dx-select-box>
